function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AustraliaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4863",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18,
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4863)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H24V21H0V3Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_4863",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "14",
      height: "11",
      children: /*#__PURE__*/_jsx("rect", {
        y: "3",
        width: "13.5",
        height: "10.5",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_4863)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M-1.50317 12.7499L1.46754 14.0528L13.5674 4.41656L15.1344 2.48041L11.9577 2.04494L7.02241 6.19746L3.05003 8.99528L-1.50317 12.7499Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        d: "M-1.0965 13.6627L0.416945 14.4188L14.5717 2.30054H12.4467L-1.0965 13.6627Z",
        fill: "#F50100"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.0032 12.7499L12.0325 14.0528L-0.0673752 4.41656L-1.63436 2.48041L1.54239 2.04494L6.47765 6.19746L10.45 8.99528L15.0032 12.7499Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.9019 13.405L13.3884 14.1611L7.36117 8.97263L5.57422 8.39294L-1.78515 2.48704H0.339895L7.69513 8.25276L9.64885 8.94787L14.9019 13.405Z",
        fill: "#F50100"
      }), /*#__PURE__*/_jsxs("mask", {
        id: "path-8-outside-1_621_4863",
        maskUnits: "userSpaceOnUse",
        x: "-1",
        y: "2",
        width: "16",
        height: "13",
        fill: "black",
        children: [/*#__PURE__*/_jsx("rect", {
          fill: "white",
          x: "-1",
          y: "2",
          width: "16",
          height: "13"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z",
        fill: "#F50100"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.98838 3V2.25H5.23838V3H5.98838ZM7.48838 3H8.23838V2.25H7.48838V3ZM5.98838 7.5V8.25H6.73838V7.5H5.98838ZM0 7.5V6.75H-0.75V7.5H0ZM0 9H-0.75V9.75H0V9ZM5.98838 9H6.73838V8.25H5.98838V9ZM5.98838 13.5H5.23838V14.25H5.98838V13.5ZM7.48838 13.5V14.25H8.23838V13.5H7.48838ZM7.48838 9V8.25H6.73838V9H7.48838ZM13.5 9V9.75H14.25V9H13.5ZM13.5 7.5H14.25V6.75H13.5V7.5ZM7.48838 7.5H6.73838V8.25H7.48838V7.5ZM5.98838 3.75H7.48838V2.25H5.98838V3.75ZM6.73838 7.5V3H5.23838V7.5H6.73838ZM0 8.25H5.98838V6.75H0V8.25ZM0.75 9V7.5H-0.75V9H0.75ZM5.98838 8.25H0V9.75H5.98838V8.25ZM6.73838 13.5V9H5.23838V13.5H6.73838ZM7.48838 12.75H5.98838V14.25H7.48838V12.75ZM6.73838 9V13.5H8.23838V9H6.73838ZM13.5 8.25H7.48838V9.75H13.5V8.25ZM12.75 7.5V9H14.25V7.5H12.75ZM7.48838 8.25H13.5V6.75H7.48838V8.25ZM6.73838 3V7.5H8.23838V3H6.73838Z",
        fill: "#F7FCFF",
        mask: "url(#path-8-outside-1_621_4863)"
      })]
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.90798 16.3343L8.31755 16.8799L8.37602 16.0781L7.5813 15.9567L8.24464 15.5025L7.84406 14.8054L8.61277 15.0408L8.90798 14.2931L9.20319 15.0408L9.9719 14.8054L9.57132 15.5025L10.2347 15.9567L9.43994 16.0781L9.49841 16.8799L8.90798 16.3343Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.276 12.569L14.8824 12.9327L14.9213 12.3982L14.3915 12.3173L14.8337 12.0145L14.5667 11.5498L15.0792 11.7067L15.276 11.2082L15.4728 11.7067L15.9853 11.5498L15.7182 12.0145L16.1604 12.3173L15.6306 12.3982L15.6696 12.9327L15.276 12.569Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.2147 8.87667L15.8211 9.24043L15.8601 8.70588L15.3302 8.62494L15.7725 8.32213L15.5054 7.85744L16.0179 8.01439L16.2147 7.51587L16.4115 8.01439L16.924 7.85744L16.6569 8.32213L17.0991 8.62494L16.5693 8.70588L16.6083 9.24043L16.2147 8.87667Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.5613 10.7228L18.1677 11.0866L18.2067 10.552L17.6769 10.4711L18.1191 10.1683L17.852 9.7036L18.3645 9.86055L18.5613 9.36203L18.7581 9.86055L19.2706 9.7036L19.0035 10.1683L19.4458 10.4711L18.916 10.552L18.9549 11.0866L18.5613 10.7228Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.684 16.0305L16.2904 16.3943L16.3294 15.8598L15.7995 15.7788L16.2418 15.476L15.9747 15.0113L16.4872 15.1683L16.684 14.6697L16.8808 15.1683L17.3933 15.0113L17.1262 15.476L17.5684 15.7788L17.0386 15.8598L17.0776 16.3943L16.684 16.0305Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.3266 13.1479L17.9267 13.3581L18.0031 12.9128L17.6795 12.5974L18.1267 12.5325L18.3266 12.1273L18.5266 12.5325L18.9737 12.5974L18.6502 12.9128L18.7266 13.3581L18.3266 13.1479Z",
      fill: "#F7FCFF"
    })]
  })]
}));
//# sourceMappingURL=Australia.js.map